import {
  registerDecorator,
  type ValidationOptions,
  type ValidationArguments,
} from 'class-validator';
import { validateEmbedHtmlCode } from '@builder4/shared/utils/htmlSanitationHelpers';

/**
 * Validates that a value is either empty or safe HTML (no XSS, phishing, or dangerous elements).
 * Uses validateEmbedHtmlCode to check for dangerous patterns.
 */
export function IsSafeHtml(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isSafeHtml',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          if (typeof value !== 'string') {
            return false;
          }
          const result = validateEmbedHtmlCode(value);
          return result.isValid;
        },
        defaultMessage(args: ValidationArguments) {
          const value = args.value as string;
          if (typeof value === 'string' && value.trim()) {
            const result = validateEmbedHtmlCode(value);
            if (result.error) {
              return `${args.property}: ${result.error}`;
            }
          }
          return `${args.property} contains unsafe HTML content`;
        },
      },
    });
  };
}
